import { Button, Tooltip } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import React, { useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import {
	deleteProductFamily,
	getProductFamilies,
} from "../../../../api/productFamily";
import { ROLES } from "../../../../utils/constants";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import EntityInfoDialog from "../../../components/dialogs/EntityInfoDialog";
import Table, { buttonsStyle } from "../../../components/tables/table";
import ProductFamilyContent from "./ProductFamilyContent";

function getData(productFamilies) {
	let data = [];
	for (let i = 0; i < productFamilies.length; ++i) {
		const elem = {};
		const productFamily = productFamilies[i];

		elem.descripcion = productFamily?.descripcion;
		elem.referencia = productFamily?.referencia;
		elem.id = productFamily?.id;

		data = data.concat(elem);
	}
	return data;
}

export default function ProductFamiliesPage() {
	const [data, setData] = useState([]);
	const [selectedFamily, setSelectedFamily] = useState(null);

	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [openFamilyInfoDialog, setOpenFamilyInfoDialog] = useState(null);

	const [refresh, setRefresh] = useState(false);

	const history = useHistory();

	const loggedUser = useSelector(
		(store) => store.authentication?.user,
		shallowEqual
	);

	function buttonFormatter(cell) {
		const elem = data.find((item) => item.id === cell);
		return (
			<>
				<Tooltip title="Editar">
					<Button
						style={buttonsStyle}
						size="small"
						onClick={(e) => {
							e.stopPropagation();
							history.push(
								"/familias-productos/" + cell + "/edit"
							);
						}}
					>
						<EditIcon />
					</Button>
				</Tooltip>
				{loggedUser?.role?.rango === ROLES.SUPER_ADMIN && (
					<>
						<Tooltip title="Eliminar">
							<Button
								style={buttonsStyle}
								size="small"
								onClick={(e) => {
									e.stopPropagation();
									setSelectedFamily(elem);
									setOpenConfirmDialog(2);
								}}
							>
								<DeleteIcon />
							</Button>
						</Tooltip>
					</>
				)}
			</>
		);
	}

	const columns = [
		{ dataField: "descripcion", text: "Descripción", sort: true },
		{
			dataField: "referencia",
			text: "Referencia",
			headerAlign: "center",
			align: "center",
		},
		{ dataField: "id", text: "", formatter: buttonFormatter },
	];

	useEffect(() => {
		getProductFamilies(loggedUser?.accessToken)
			.then((res) => {
				if (res.status === 200) {
					setData(res.data);
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({
					error: error,
					customMessage: "No se han podido obtener las familias.",
				});
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title="Familias de productos">
					<CardHeaderToolbar>
						<button
							type="button"
							className="btn btn-primary"
							onClick={() =>
								history.push("/familias-productos/edit")
							}
						>
							Nueva familia
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table
						data={getData(data)}
						columns={columns}
						rowEvents={{
							onClick: (e, row, rowIndex) => {
								const family = data?.find(
									(x) => x.id === row.id
								);
								setSelectedFamily(family);
								setOpenFamilyInfoDialog(true);
							},
						}}
					/>
					<ConfirmDialog
						title={
							"¿Estás seguro de que quieres eliminar esta familia de producto?"
						}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteProductFamily(
								selectedFamily?.id,
								loggedUser?.accessToken
							)
								.then((res) => {
									if (
										res.status === 204 ||
										res.status === 200
									) {
										alertSuccess({
											title: "¡Eliminado!",
											customMessage:
												"Familia eliminada con éxito.",
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage:
											"No se ha podido eliminar la familia.",
									});
								});
						}}
					/>
					<EntityInfoDialog
						title={"Familia: " + selectedFamily?.descripcion}
						open={openFamilyInfoDialog}
						setOpen={setOpenFamilyInfoDialog}
						content={
							<ProductFamilyContent family={selectedFamily} />
						}
					/>
				</CardBody>
			</Card>
		</>
	);
}
